"use client";

import { useContext } from "react";
import { useStore } from "zustand";
import { OverviewPreviewStoreContext } from "../../../OverviewPreviewProvider/OverviewPreviewProvider";
export const useCollectionLogoMediaPreview = () => {
  const overviewPreviewStoreContext = useContext(OverviewPreviewStoreContext);
  if (!overviewPreviewStoreContext) {
    return null;
  }
  const logoMedia = useStore(overviewPreviewStoreContext, state => state.logoMedia);
  return logoMedia;
};